// Text Replacement Script for Shopify
// This script replaces all instances of "Lustrick" with "Chek" on page load

document.addEventListener('DOMContentLoaded', function() {
  // Function to replace text in all text nodes
  function replaceTextInNode(node) {
    if (node.nodeType === 3) { // Text node
      // Replace the text content
      if (node.textContent.includes('Lustrick')) {
        node.textContent = node.textContent.replace(/Lustrick/g, 'Chek');
      }
    } else if (node.nodeType === 1) { // Element node
      // Skip script tags to avoid modifying code
      if (node.tagName.toLowerCase() !== 'script' && node.tagName.toLowerCase() !== 'style') {
        // Recursively process child nodes
        Array.from(node.childNodes).forEach(replaceTextInNode);
      }
    }
  }

  // Start the replacement process from the body
  replaceTextInNode(document.body);

  // Also add a mutation observer to handle dynamically loaded content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(replaceTextInNode);
      }
    });
  });

  // Configure and start the observer
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});